<div class="min-h-screen bg-slate-50 text-slate-800">
  <app-course-sidebar
    [variant]="'course-viewer'"
    [isOpen]="isSidebarOpen"
    [course]="course"
    (closeSidebar)="onCloseSidebar()"
    (lessonClick)="onLessonClick($event)"
  />
  @if (isSidebarOpen) {
  <div
    class="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm transition-opacity lg:hidden"
    (click)="onToggleSidebar()"
    aria-hidden="true"
  ></div>
  }

  <div
    class="relative flex min-h-screen flex-col transition-all"
    [ngClass]="{
      'lg:ms-[300px]': isSidebarOpen,
      'lg:ms-0': !isSidebarOpen
    }"
  >
    <app-course-header
      [sidebarCollapsed]="!isSidebarOpen"
      [applicationTitle]="'Visualizador de cursos'"
      (toggleSidebar)="onToggleSidebar()"
    />

    <div class="flex-1 overflow-hidden pt-[48px]">
      <div class="grid grid-cols-1 lg:grid-cols-12 h-[calc(100vh-48px)]">
        <!-- Área de Conteúdo SCORM (Stage) - altura fixa -->
        <div
          class="col-span-1 lg:col-span-9 relative"
          style="height: calc(100vh - 48px)"
        >
          <!-- Container com scroll para o conteúdo - altura ajustada para o footer -->
          <div
            class="w-full overflow-y-auto"
            [style.height]="navigation && currentModule && currentLesson ? 'calc(100% - 128px)' : '100%'"
          >
            <!-- Conteúdo Dinâmico -->
            <div class="w-full" #contentContainer></div>
          </div>

          <!-- Footer fixo no bottom do stage -->
          @if (navigation && currentModule && currentLesson) {
          <div
            class="absolute bottom-0 left-0 right-0 w-full z-10 bg-white dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-700"
          >
            <app-course-viewer-footer
              [progress]="lessonProgress"
              [remainingTime]="remainingTime"
              [sidebarCollapsed]="!isSidebarOpen"
              [currentLesson]="navigation.currentLessonIndex + 1"
              [totalLessons]="totalLessonsInModule"
              [moduleName]="currentModule.name"
              [canGoPrevious]="navigation.canGoPrevious"
              [canGoNext]="navigation.canGoNext"
              (previous)="onPreviousLesson()"
              (next)="onNextLesson()"
            />
          </div>
          }
        </div>

        <!-- Barra Lateral Direita - Dividida Verticalmente -->
        <div class="col-span-1 lg:col-span-3">
          <app-course-info
            [variant]="'course-viewer'"
            [course]="course"
            [currentModule]="currentModule"
            [currentLesson]="currentLesson"
            [totalProgress]="totalProgress"
            [displayTitle]="displayTitle"
          />
        </div>
      </div>
    </div>
  </div>
</div>
